import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import OPTS from "../views/OPTS.vue";
import Auth from "../views/Auth.vue";
import SignOut from "../views/SignOut.vue";
import Amplify from "aws-amplify";
import AmplifyStore from "../store";
import { Hub } from "@aws-amplify/core";

Vue.use(VueRouter);

function getUser() {
  return Amplify.Auth.currentAuthenticatedUser()
    .then((data: { signInUserSession: any }) => {
      if (data && data.signInUserSession) {
        AmplifyStore.commit("setUser", data);
        return data;
      }
    })
    .catch(() => {
      AmplifyStore.commit("setUser", null);
      return null;
    });
}

Hub.listen("auth", async (data) => {
  switch (data.payload.event) {
    case "signIn":
      router.push({ path: "/" });
      break;
    case "signOut":
      router.push({ path: "/" });
      break;
  }
});

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "OPTS",
    component: OPTS,
    meta: { requiresAuth: true },
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/auth",
    name: "auth",
    component: Auth,
  },
  {
    path: "/signout",
    name: "signout",
    component: SignOut,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

getUser().then((user: any) => {
  if (user) {
    router.push({ path: "/" });
  }
});

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    let user = await getUser(); // ページ切り替わりのタイミングでユーザを確認する
    /*
    if (!user) {
      return next({
        path: "/auth",
        query: {
          redirect: to.fullPath,
        },
      });
    }
    */
    return next();
  }
  return next();
});
window.webkitCancelAnimationFrame;

export default router;
